module.exports = __webpack_public_path__ + "static/media/LP3.efa34c01.jpg";